import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './BrandSafetyTwo.style';

const BrandSafetyTwo = () => {
  const { t } = useTranslation('brandSafety');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('brandSafetyTwo.title')}</h1>
        <StyledHr />
      </SectionWrapper>
      <ContentWrapper>
        <p>{t('brandSafetyTwo.subtitle')}</p>
        <div>
          <TextBox1>
            <p>{t('brandSafetyTwo.paragraphOne.title')}</p>
            <TextBox2>
              <p>{t('brandSafetyTwo.paragraphOne.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1>
            <p>{t('brandSafetyTwo.paragraphTwo.title')}</p>
            <TextBox2>
              <p>{t('brandSafetyTwo.paragraphTwo.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="empty-content">
            <p></p>
            <TextBox2>
              <p></p>
            </TextBox2>
          </TextBox1>
        </div>

        {/* Segunda fileira */}
        <div>
          <TextBox1 className="empty-content">
            <p></p>
            <TextBox2>
              <p></p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="content-left">
            <p>{t('brandSafetyTwo.paragraphThree.title')}</p>
            <TextBox2>
              <p>{t('brandSafetyTwo.paragraphThree.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
        <div>
          <TextBox1 className="content-left">
            <p>{t('brandSafetyTwo.paragraphFour.title')}</p>
            <TextBox2>
              <p>{t('brandSafetyTwo.paragraphFour.paragraph')}</p>
            </TextBox2>
          </TextBox1>
        </div>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default BrandSafetyTwo;
